import { memo } from "react";
import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { StatusResourceTableCell } from "ui/organizms/Merchants/Merchants/shared/TableCells";
import { Status } from "consts/users";
import { useTypedSelector } from "hooks";
import useUserActions from "features/users/useActions";
import { selectIsProfileLoading } from "features/users/selectors";
import useMerchantUserActions from "features/merchants/useMerchantUserActions";
import type { User } from "features/users/types";
import type { CoreBankingEntity } from "types";

const MerchantUserStatus = (props: GridRenderCellParams) => {
    const isProfileLoading = useTypedSelector(selectIsProfileLoading);

    const { updateOrAddMerchantUserById } = useMerchantUserActions();

    const { updateOrCreateUser } = useUserActions();

    const handleProcess = async (isChecked: boolean, { row }: GridRenderCellParams) =>
        updateOrCreateUser({
            coreId: row.coreId,
            status: isChecked
                ? Status.Active
                : Status.Inactive
        });

    const update = (user: CoreBankingEntity) => {
        updateOrAddMerchantUserById(user as User);
    };

    const getChecked = ({ value }: GridRenderCellParams) => Object.is(value, Status.Active);

    return (
        <StatusResourceTableCell
            {...props}
            isProcessing={isProfileLoading}
            getChecked={getChecked}
            handleProcess={handleProcess}
            update={update}
        />
    );
};

export default memo(MerchantUserStatus);
